import { render, staticRenderFns } from "./ResellerServiceViewGallery.vue?vue&type=template&id=0cf69dcb"
import script from "./ResellerServiceViewGallery.vue?vue&type=script&lang=js"
export * from "./ResellerServiceViewGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports